<script setup lang="ts">
import type { TextLinkProps } from '.';

import { cn } from '@/utils';
import { Primitive } from 'radix-vue';

import { textLinkVariants } from '.';

const props = withDefaults(defineProps<TextLinkProps>(), {
	as: 'a',
	variant: 'default'
});

const computedClass = computed(() =>
	cn(textLinkVariants({ variant: props.variant }), props.class)
);
</script>

<template>
	<Primitive :as="props.as" :class="computedClass">
		<slot></slot>
	</Primitive>
</template>
